import { TOGGLE_SIGNATURE_MODAL_VISIBILITY, SET_SIGNATURE_MODAL_DATA } from '../actions/actionTypes'

const initState = {
    sigPopupVisibility : false,
    sigPopupDetails : {
        signContnent : "",
        signStatus : "",
        basicCellData : "",
        visible : "",
        onHide : "",
        origin : ""
    },
}

const userDetailReducer = (state = initState, action) => {
    switch(action.type){
        case TOGGLE_SIGNATURE_MODAL_VISIBILITY : return {
            ...state,
            sigPopupVisibility : !state.sigPopupVisibility,
        }
        case SET_SIGNATURE_MODAL_DATA : return {
            ...state,
            sigPopupDetails : action.sigPopupDetails,
            sigPopupVisibility : true,
        }
        default : return state
    }
};

export default userDetailReducer;